export var deserialize = function (data) { return data === 'undefined' ? undefined : JSON.parse(data); };
export var serialize = function (data) { return data === undefined ? 'undefined' : JSON.stringify(data); };
